import { colors } from "../components/Theme/WebTheme";

export const FONT_FAMILY = '"Roboto", "Helvetica", "Arial", sans-serif';

export const WEB_MAIN_COLOR = (appCat) =>
  appCat === "bidcab"
    ? colors.BIDTAXIPRIMARY
    : appCat === "delivery"
      ? colors.DELIVERYPRIMARY
      : colors.Header; // Bleu stable

export const WEB_SECONDORY_COLOR = (appCat) =>
  appCat === "bidcab"
    ? colors.BIDTAXISECONDORY
    : appCat === "delivery"
      ? colors.DELIVERYSECONDORY
      : colors.TAXISECONDORY;

export const MAIN_COLOR = colors.Header; // Bleu pour boutons
export const SIDEBAR_COLOR = colors.TAXIPRIMARY; // Slate sombre fixe pour sidebar
export const SECONDORY_COLOR = colors.Header_Background;
export const ADAPTIVE_COLOR = colors.Header_Content; // Adaptatif pour les textes
